export const FED_LOGIN_URL = `https://console.dev.cloud.leroymerlin.it/saml/dologin?cb=${window.location.href}`
export const FED_TOKEN = 'fedToken'
